<template>
  <CardItem :show-top-bar="false">
    <div class="flex flex-grow items-center justify-center">
      <TextTitle>
        <template #icon>
          <ik-image
              v-if="survey.image_src"
              :src="survey.image_src | parseImgUrl"
              style="max-width: 50px; height: 50px;"
              class="mb-1 object-contain w-full select-none pointer-events-none"
              alt="Logo"
          />
        </template>
        {{ survey.welcomeScreen.title || default_messages.title }}
        <template #description>
          <TextCollapsed
              :title="survey.welcomeScreen.description || default_messages.description"
              :max-length="300"
          />
        </template>
      </TextTitle>
    </div>
    <template #button>
      <a-button
          class="btn-action-primary"
          :style="[buttonBgColor, buttonTextColor]"
          @click="onStart"
      >
        {{
          survey.translations.welcomeScreen.buttonStart.value || survey.translations.welcomeScreen.buttonStart.defaultValue
        }}
      </a-button>
    </template>
  </CardItem>
</template>

<script>
import {questionEventListenerMixin} from "@/mixins/question";
import {mapGetters} from "vuex";
import themeMixin from "../../mixins/theme.mixin";
import CardItem from "../CardItem";
import TextCollapsed from "../TextCollapsed";
import TextTitle from "../TextTitle";
import {parseImgUrl} from "../../helpers/fns";

export default {
  name: "ScreenWelcome",
  props: {
    isCurrent: {
      type: Boolean,
      default: false
    },
  },
  components: {CardItem, TextCollapsed, TextTitle},
  mixins: [questionEventListenerMixin, themeMixin],
  filters: {parseImgUrl},
  data() {
    return {
      default_messages: {
        title: 'Welcome',
        description: 'Please take this survey and let us know about your experience.',
      }
    }
  },
  computed: {
    ...mapGetters(["survey"])
  },
  methods: {
    onStart() {
      this.$emit('next');
    },
    onKeyDown(e) {
      if (!this.isCurrent) return;

      if (e.key === 'Enter') {
        this.onStart();
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
